/**
 * Envío de eventos al CRM (Hubspot vía nuestro propio servidor).
 *
 * Sustituye al paquete `event-tracking`, que vivía en un repositorio de Bitbucket
 * que dejó de existir. De su superficie pública este proyecto sólo usaba
 * `initTracker()` y `tracker('send', 'event', ...)`, así que se reimplementa aquí.
 *
 * Se mantiene el comportamiento del original: POST multipart, sin cookies,
 * disparar y olvidar, y los errores se ignoran para no romper la navegación.
 */

export interface TrackerData {
    email?: string;
    category?: string | null;
    action?: string | null;
    label?: string | null;
    value?: number;
    [key: string]: any;
}

let api = '';

export const initTracker = (endpoint: string) => {
    api = endpoint;
};

export const tracker = (command: 'send', hitType: 'event', fieldsObject: TrackerData): void => {
    if ('send' !== command || 'event' !== hitType || !api) return;

    const formData = new FormData();

    // Se recorren todas las claves, incluidas las que valen null: el original
    // usaba FormData.append igual, que las serializa como la cadena "null".
    for (const key in fieldsObject) {
        formData.append(key, fieldsObject[key]);
    }

    try {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', api, true);
        // Sin Content-Type explícito: lo pone el navegador con su boundary.
        xhr.send(formData);
    } catch (error) {}
};
